/* src/app/welcome/welcome.component.scss */
.carousel {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.carousel .carousel-inner {
  display: table-cell;
  height: 100%;
  vertical-align: middle;
}
.carousel .carousel-item {
  padding-top: 50px;
  height: auto;
}
.custom-next {
  margin-top: 20px;
}
ul {
  padding-inline-start: 20px;
}
ul li {
  font-size: 1.286rem;
  line-height: 1.5;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}
.long-container p {
  margin-bottom: 10px;
  width: 1000px;
}
.general2-long-container {
  width: 1000px;
}
.general2-long-container p {
  margin-bottom: 10px;
}
@media screen and (max-height: 650px) {
  .text-content h1 {
    margin-top: 20px;
  }
}
@media screen and (max-height: 600px) {
  .text-content h1 {
    margin-top: 10px;
  }
}
@media screen and (max-height: 550px) {
  .text-content h1 {
    margin-top: 0;
  }
}
.welcome .how-long {
  font-size: 34px;
}
.welcome {
  text-align: left;
  padding: 50px 140px;
  height: 100%;
  width: 64%;
}
.welcome .btn {
  margin-bottom: 5%;
}
.welcome .parts {
  margin-top: 50px;
  margin-bottom: 50px;
}
.welcome .part {
  display: flex;
  margin-bottom: 20px;
}
.welcome .part p {
  font-size: 34px;
  line-height: 46px;
}
.welcome .part .number {
  display: block;
  color: black;
  background: white;
  border-radius: 60px;
  font-family: "Campton-Bold";
  width: 60px;
  height: 60px;
  font-size: 34px;
  line-height: 67px;
  text-align: center;
  margin-bottom: 20px;
}
.welcome .part img {
  display: inline-block;
  width: 300px;
  margin-right: 10px;
}
#references {
  all: unset;
  margin-bottom: 20px;
  margin-right: 40px;
  float: right;
  border-bottom: 1px dashed #ffffff;
  padding-bottom: 2px;
  font-size: 1.5em;
}
#references:hover {
  cursor: pointer;
}
/*# sourceMappingURL=welcome.component.css.map */
